import type {
  InfoSecurityIncidentSeverity,
  InfoSecurityIncidentStatus,
  InfoSecurityIncidentType,
} from './types';

export const INCIDENT_TYPE_LABEL: Record<InfoSecurityIncidentType, string> = {
  breach: 'Brecha de seguridad',
  malware: 'Malware',
  phishing: 'Phishing',
  unauthorized_access: 'Acceso no autorizado',
  data_leak: 'Fuga de datos',
  other: 'Otro',
};

export const SEVERITY_LABEL: Record<InfoSecurityIncidentSeverity, string> = {
  low: 'Baja',
  medium: 'Media',
  high: 'Alta',
  critical: 'Crítica',
};

export const STATUS_LABEL: Record<InfoSecurityIncidentStatus, string> = {
  abierto: 'Abierto',
  en_investigacion: 'En investigación',
  contenido: 'Contenido',
  cerrado: 'Cerrado',
};

export function severityBadgeClass(severity: InfoSecurityIncidentSeverity): string {
  if (severity === 'critical') return 'bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-200';
  if (severity === 'high') return 'bg-orange-100 text-orange-800 dark:bg-orange-950 dark:text-orange-200';
  if (severity === 'medium') return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-950 dark:text-yellow-200';
  return 'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-200';
}

export function statusBadgeClass(status: InfoSecurityIncidentStatus): string {
  if (status === 'cerrado') return 'bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-200';
  if (status === 'contenido') return 'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-200';
  if (status === 'en_investigacion') {
    return 'bg-purple-100 text-purple-800 dark:bg-purple-950 dark:text-purple-200';
  }
  return 'bg-muted text-muted-foreground';
}
